import type { SxProps, Theme } from '@mui/material/styles'
import { TABLE_ROW_EXPANDED_BG } from '../tableList/tableListTokens'
import { KIOT_EXPAND_FRAME_ATTR } from './kiotListExpandTokens'

/** Ẩn gạch ngang mặc định của ô hàng đang expand — sticky sát dưới thead. */
export function kiotExpandDataRowCellSx(
  _theme: Theme,
  _colIndex: number,
  _totalCols: number,
  isExpandedWithPanel: boolean,
  stickyTopPx?: number,
): Record<string, unknown> {
  if (!isExpandedWithPanel) return {}
  const top =
    stickyTopPx != null && stickyTopPx >= 0
      ? stickyTopPx
      : 'var(--kiot-expand-sticky-top, 42px)'
  return {
    borderBottom: 'none !important',
    boxShadow: 'none !important',
    position: 'sticky',
    top,
    zIndex: 11,
  }
}

/** @deprecated Viền expand dùng portal — không cần sx hàng. */
export function kiotExpandDataRowRowSx(_isExpandedWithPanel: boolean): Record<string, unknown> {
  return {}
}

/** Thuộc tính `TableRow` chuẩn cho hàng có inline expand Kiot. */
export function kiotExpandDataRowAttrs(options: {
  isExpandedWithPanel: boolean
  showExpandOnRowClick?: boolean
  isSelected?: boolean
}): Record<string, string | boolean | undefined> {
  const { isExpandedWithPanel, showExpandOnRowClick, isSelected } = options
  return {
    [KIOT_EXPAND_FRAME_ATTR]: isExpandedWithPanel ? 'true' : undefined,
    'aria-expanded': showExpandOnRowClick ? isSelected : undefined,
  }
}

/** Sx bổ sung cho `TableList.tableSx` khi dùng inline expand Kiot. */
export function kiotListExpandTableSx(options?: { expandRowHoverBg?: string }): SxProps<Theme> {
  const hoverBg = options?.expandRowHoverBg ?? TABLE_ROW_EXPANDED_BG
  return {
    position: 'relative',
    '& .MuiTable-root': { borderCollapse: 'separate', borderSpacing: 0 },
    [`& .MuiTableBody-root .MuiTableRow-root[${KIOT_EXPAND_FRAME_ATTR}="true"] .MuiTableCell-root`]: {
      borderBottom: 'none !important',
      backgroundColor: `${TABLE_ROW_EXPANDED_BG} !important`,
      position: 'sticky',
      top: 'var(--kiot-expand-sticky-top, 42px)',
      zIndex: 11,
    },
    [`& .MuiTableBody-root .MuiTableRow-root[${KIOT_EXPAND_FRAME_ATTR}="true"]:hover .MuiTableCell-root`]: {
      backgroundColor: `${hoverBg} !important`,
    },
  }
}
